module.exports = __webpack_public_path__ + "img/flot1.77131d37.svg";